<div class="major-frameworks">

  <h2 l10nTranslate>
    Instant Access To Major Frameworks
  </h2>
  <div l10nTranslate class="major-frameworks__description" [innerHTML]="'Start your compliance assessment quickly with 25+ predefined frameworks or add your own'"></div>

  <div class="major-frameworks_container">
    <div class="container__card">
      <ng-container *ngFor="let item of sectionCards">
        <div class="major-frameworks_names-holder">
          <div class="major-frameworks_names" [ngClass]="{'major-frameworks__custom': item.frameWorkName == 'CUSTOM'}" l10nTranslate>{{item?.frameWorkName}}</div>
        </div>
      </ng-container>
    </div>
  </div>


</div>